import { createFileRoute } from "@tanstack/react-router";

import SignUpMessage from "@/features/auth/SignupMessage";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/sign-up-continue")({
  component: () => (
    <BasicLayout>
      <SignUpMessage />
    </BasicLayout>
  ),
});
